module.exports = __webpack_public_path__ + "img/player_bg.c0870689.png";